import '../App.css'
import LogoIcon from '../images/logoicon.png'

import { useNavigate } from 'react-router-dom'

function NavBar() {

    const navigate = useNavigate()


    return (
        <div className="navbar">
            <div className="logo" onClick={() => navigate('/')}>
                <img className="logoimage" src={LogoIcon} alt="logo"></img><b>SimplifyAI</b>
            </div>
            <div className="navlinks">
                <div className="navlink" onClick={() => navigate('/about')}>About</div>
                <div className="navlink" onClick={() => navigate('/services')}>Services</div>
                <div className="navlink" onClick={() => navigate('/contact')}>Contact</div>
            </div>
            <div className="consultbutton" onClick={() => navigate('/consultation')}>Free Consultation</div>

        </div>
    )

}

export default NavBar